import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";

const LanguageToggle = () => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    const savedLang = localStorage.getItem("language") || "en";
    i18n.changeLanguage(savedLang);
    setLanguage(savedLang);
  }, [i18n]);

  const toggleLanguage = () => {
    const newLang = language === "en" ? "sw" : "en";
    i18n.changeLanguage(newLang);
    localStorage.setItem("language", newLang);
    setLanguage(newLang);
  };

  return (
    <li className="list-none">
      <button
        onClick={toggleLanguage}
        className="flex items-center justify-center bg-gradient-to-r from-green-500 to-yellow-700 text-white py-2 px-3 rounded-md hover:opacity-90 transition-opacity"
      >
        <Languages size={16} className="mr-1" />
        <span>{language === "en" ? "Swahili" : "English"}</span>
      </button>
    </li>
  );
};

export default LanguageToggle;
